import { useNotification } from '../contexts/NotificationContext'
import { removeBracketFromGroup, removeTournamentFromGroup } from '../services/groupService'

// Owner actions to take a bracket or a whole tournament out of a group. Both
// record an exclusion server-side, so the copy says it won't come back.
export default function useGroupBracketRemoval(groupId, onChanged) {
  const notify = useNotification()

  const removeBracket = async ({ bracketId, label }) => {
    const confirmed = await notify.confirm({
      title: 'Remove bracket',
      description: `Remove ${label} from this group? It won't be added back automatically.`,
      confirmText: 'Remove',
      cancelText: 'Cancel'
    })
    if (!confirmed) return
    try {
      await removeBracketFromGroup({ groupId, bracketId })
      notify.success('Bracket removed')
      onChanged?.()
    } catch (err) {
      console.error('Error removing bracket:', err)
      notify.error(err.message || 'Failed to remove bracket')
    }
  }

  const removeTournament = async ({ tournamentId, name }) => {
    const confirmed = await notify.confirm({
      title: 'Remove tournament',
      description: `Remove every ${name} bracket from this group? They won't be added back automatically.`,
      confirmText: 'Remove',
      cancelText: 'Cancel'
    })
    if (!confirmed) return
    try {
      await removeTournamentFromGroup({ groupId, tournamentId })
      notify.success(`${name} removed`)
      onChanged?.()
    } catch (err) {
      console.error('Error removing tournament:', err)
      notify.error(err.message || 'Failed to remove tournament')
    }
  }

  return { removeBracket, removeTournament }
}
